import { render, staticRenderFns } from "./profile_list.vue?vue&type=template&id=0ff96c73&scoped=true&lang=html&"
import script from "./profile_list.vue?vue&type=script&lang=js&"
export * from "./profile_list.vue?vue&type=script&lang=js&"
import style0 from "./profile_list.vue?vue&type=style&index=0&id=0ff96c73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff96c73",
  null
  
)

export default component.exports